// The co2 chips live inside the product-info container, so a packs-dropdown
// repaint replaces them. Re-bind on `product-info-repainted`. After a swap the
// chips are brand-new elements, so re-running never stacks listeners.
initCo2Chips();
window.addEventListener('product-info-repainted', initCo2Chips);

function initCo2Chips() {
  const chips = document.querySelectorAll('.chip.co2-label');

  chips.forEach((chip) => {
    chip.addEventListener('click', (event) => {
      const sectionFeatures = document.querySelectorAll('.section--features.collection');
      if (!sectionFeatures.length) return;

      sectionFeatures.forEach((element) => {
        if (element.id !== 'features-footprint') {
          element.classList.add('d-none');
        } else {
          element.classList.remove('d-none');
        }
      });

      const footprintSection = document.getElementById('features-footprint');
      if (!footprintSection) return;

      const scrollValue = footprintSection.getBoundingClientRect().top + window.pageYOffset;
      const href = chip.getAttribute('href') || '';

      // trigger scroll animation only if chip url setting is empty
      if (href.trim() === '#') {
        event.preventDefault();
        window.scrollTo({
          top: scrollValue,
          behavior: 'smooth',
        });
      }
    });
  });
}
